/**
 * Accepts either a bare slug ("hacker-7") or a scanned/pasted QR url
 * ("https://hack.platan.us/26-co/id/hacker-7") and keeps the last path segment.
 * Ruby side: `PrintedCredential.normalize_slug`.
 */
export function normalizeCredentialSlug(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';
  const withoutQuery = trimmed.split(/[?#]/)[0];
  const segment = withoutQuery.replace(/\/+$/, '').split('/').pop() ?? '';
  return segment.toLowerCase().replace(/^@/, '');
}
